export default "__VITE_ASSET__C2xBuH8W__"